import React from 'react';
import { Tr } from 'Shared/components/i18n/Tr';

import { browserVersion, isIE } from 'react-device-detect';

export default function UnsupportedBrowserAlert() {
  if (!isIE) return null;
  return (
    <div className="alert alert-danger position-absilute mb-0" role="alert">
      <Tr
        trKey="perform.one_on_one_dashboard.unsupported_browser.full_message"
        params={[String(browserVersion)]}
        components={{
          chrome: p => (
            <a target="_blank" rel="noopener noreferrer" href="https://www.google.com/chrome/">
              {p.children}
            </a>
          ),
          edge: p => (
            <a target="_blank" rel="noopener noreferrer" href="https://www.microsoft.com/en-us/edge">
              {p.children}
            </a>
          ),
        }}
      />
    </div>
  );
}
